import React from 'react';
export const EbookMockup = () => {
  return <div className="relative w-full max-w-xl mx-auto animate-float" data-id="element-13">
      <img src="https://cdn.magicpatterns.com/uploads/x3A2YhYqXJ9VKB8jGvgfp4/imagen_2_EA.png" alt="The AI Firewall ebook shown across hardcover book, tablet, and phone" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-14" />
    </div>;
};